import React from 'react'

const About = () => {
    return (
        <div className="about">
            <h1>About</h1>

            <h2>Search over 2.3 million English and 200,000 Spanish recipes
            </h2>
            <ul>
                <li>Search our large recipe database. We add new sites and recipes continuously.</li>
                <li>You will also get access to over 200,000 recipes from top Spanish and Latin-American cooking sites and blogs</li>
            </ul>
            <h2>500+ top web recipe sources</h2>
            <ul>
                <li>Our search algorithm returns the most relevant recipes from the most popular and best recipes sources on the web.</li>
                <li>We order recipes by their cookability and quality, so your customer can always count on getting the best recipes!</li>
            </ul>
            <h2>Semantically organized database</h2>
            <ul>
                <li>The recipes in our database are normalized and can be filtered in the search by keyword and diet preferences.</li>
            </ul>
            <h2>Filter by calories, diet or allergy restrictions
</h2>
            <ul>
                <li>Edamam API has developed over 80 diet and health filters for you to use. </li>
            </ul>
        </div>
    );
}

export default About;
